import * as Sentry from '@sentry/react';
import { initSentry } from './utils/sentry';

// Browser-tier telemetry → shared GlitchTip `web-suites` project, tagged
// spa=registration-suite. Must run before the tree renders.
initSentry('registration-suite');

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error occurred. Please reload the page.</p>}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
